import React, { useEffect } from 'react'
import {
  Flex,
  Stack,
  Heading,
  SimpleGrid,
  Text,
  Image,
  Divider,
  useColorModeValue
} from "@chakra-ui/react";
import { useDispatch, useSelector } from 'react-redux';
import { getReportesVentas, getReportesVentasMensuales, getRankingVentasClientes} from '../../features/reportesSlice';
import { ToastChakra } from '../../helpers/toast';
import { Loading } from '../../helpers/Loading';
import SalesChartMonth from './SalesChartMonth';
import ICONDAY from '../../assets/icons/v-dia.png';
import ICONWEEK from '../../assets/icons/v-semana.png';
import ICONMONTH from '../../assets/icons/v-mes.png';
import ICONYEAR from '../../assets/icons/v-anio.png';
import RankingClientes from './RankingClientes';

const Home = () => {

  const dispatch = useDispatch();


 // 👇 Asegúrate que estás accediendo al estado correcto
  const { reportesVentas, reportesVentasMensuales,rankingVentasClientes,isLoading, isError, message } = useSelector((state) => state.reportes);


  useEffect(() => {
    dispatch(getReportesVentas());
    dispatch(getReportesVentasMensuales());
    dispatch(getRankingVentasClientes());
  }, [dispatch]);

   if (isError) {
     ToastChakra('Error', message, 'error', 1500);
     console.log(message);
   }

   if (isLoading) {
     return <Loading />
   }

    // Formatear el precio a moneda con separadores de miles
    const formatCurrency = (value) => {
      return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true, // 🔹 Esto activa los puntos de miles
      }).format(value);
  };

  return (
    <Flex
      w="full"
      alignItems="center"
      justifyContent="center"
    >
      <Stack spacing={4} w="full" direction={'column'}>
        <Heading fontWeight="extrabold" fontSize={{ base: "md", lg: "2xl" }}>
         Dashboard
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={2}>
          <CardHome
            montoRecaudado={formatCurrency(reportesVentas?.ventasHoy)}
            textHeader="Total Recaudado de Hoy"
            textButton="Ver"
            cardImage={ICONDAY}
          />
          <CardHome
            montoRecaudado={formatCurrency(reportesVentas?.ventasSemana)}
            textHeader="Total Recaudado de la Semana"
            textButton="Ver"
            cardImage={ICONWEEK}
          />
          <CardHome
            montoRecaudado={formatCurrency(reportesVentas?.ventasMes)}
            textHeader="Total Recaudado del Mes"
            textButton="Ver"
            cardImage={ICONMONTH}
          />
          <CardHome
            montoRecaudado={formatCurrency(reportesVentas?.ventasAnioActual)}
            textHeader={`Total Recaudado del Año ${new Date().getFullYear()}`}
            textButton="Ver"
            cardImage={ICONYEAR}
          />
        </SimpleGrid>
        <Divider />
          <SalesChartMonth data={reportesVentasMensuales || []} />
        <Divider />
        <Divider />
          <RankingClientes data={rankingVentasClientes || []} />
        <Divider />
      </Stack>
    </Flex>
  )
}

export default Home;

const CardHome = ({ montoRecaudado, textHeader, cardImage }) => {

  const textColor = useColorModeValue('gray.700', 'gray.100');

  return (
    <Stack
      boxShadow={'base'}
      bg="white"
      _dark={{ bg: "primary.1000" }}
      rounded={'2xl'}
      p={2}
    >
      <Stack spacing={4} align={'center'} px={2} py={5} direction="row">
        <Image
          src={cardImage}
          boxSize={{
            base: '40px',
            md: '40px',
            lg: '50px'
          }}
        />
        <Stack direction="column" spacing={0}>
          <Text color={textColor} fontSize="xs" noOfLines={1}>{textHeader}</Text>
          <Text fontWeight={600} color={textColor} fontSize={{ base: 'md', md: 'lg', lg: '2xl' }}>
           {montoRecaudado}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  )
}